import { createApp } from "vue";
import "../registerServiceWorker";
import { store, key } from "../store";
import { createSidClient, sidClient } from "../plugins/auth";
import { VueReCaptcha } from "vue-recaptcha-v3";
import { createGtm } from "vue-gtm";
import UomoApp from "@/UomoApp.vue";
import { uomoRouter } from "@/router/uomo";
import { SidClientConfig } from "@sid/sid_client";

const appComponent = UomoApp;
const router = uomoRouter;
const gtmId = process.env.VUE_APP_GTM_ID_UOMO;

const config: SidClientConfig = {
    authInfo: {
        region: process.env.VUE_APP_SID_COGNITO_REGION,
        userPoolId: process.env.VUE_APP_SID_COGNITO_USER_POOL_ID,
        clientId: process.env.VUE_APP_UOMO_COGNITO_CLIEND_ID,
        cognitoBaseURI: process.env.VUE_APP_SID_COGNITO_BASE_URI,
        identityPoolId: process.env.VUE_APP_SID_COGNITO_IDENTITY_POOL_ID,
    },
    apiServerInfo: {
        region: process.env.VUE_APP_API_REGION,
        host: process.env.VUE_APP_API_HOST,
        baseUrl: process.env.VUE_APP_API_BASE_URL,
    }
};

// Cookieを使用する場合
if (process.env.VUE_APP_USE_COOKIE.toLowerCase() == "true") {
    config.authInfo.cookieStorageData = {
        domain: process.env.VUE_APP_COOKIE_DOMAIN,
        secure: process.env.VUE_APP_COOKIE_SECURE.toLowerCase() == "true",
        path: process.env.VUE_APP_COOKIE_PATH,
        expires: Number(process.env.VUE_APP_COOKIE_EXPIRES),
    };
}
createSidClient(config);

const app = createApp(appComponent)
    .use(sidClient)
    .use(store, key)
    .use(router)
    .use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY });

if (gtmId) {
    app.use(
        createGtm({
            id: gtmId,
            // queryParams: {
            //     // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
            //     gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
            //     gtm_preview: 'env-4',
            //     gtm_cookies_win: 'x',
            // },
            // defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
            // compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
            // nonce: '2726c7f26c', // Will add `nonce` to the script tag
            // enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
            // debug: true, // Whether or not display console logs debugs (optional)
            // loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
            // vueRouter: router, // Pass the router instance to automatically sync with router (optional)
            // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
            // trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
        })
    );
}

app.mount("#app");

require("@/assets/sass/style.scss");